import { MusicPlayer } from './music.js';
import { Sfx } from './sfx.js';
export class AudioBus {
  enabled = true;
  private ctx: AudioContext | null = null;
  private master: GainNode | null = null;
  private unlocked = false;
  context(): AudioContext | null {
    if (this.ctx) return this.ctx;
    const Ctor = window.AudioContext ?? null;
    if (!Ctor) return null;
    try {
      this.ctx = new Ctor();
      this.master = this.ctx.createGain();
      this.master.gain.value = 0.55;
      this.master.connect(this.ctx.destination);
    } catch {
      this.ctx = null;
    }
    return this.ctx;
  }
  installUnlockListeners(): void {
    if (this.unlocked) return;
    this.unlocked = true;
    const resume = (): void => {
      const ctx = this.context();
      if (ctx && ctx.state === 'suspended') void ctx.resume().catch(() => {});
    };
    window.addEventListener('keydown', resume, { passive: true });
    window.addEventListener('pointerdown', resume, { passive: true });
  }
  output(): {
    ctx: AudioContext;
    dest: AudioNode;
  } | null {
    if (!this.enabled) return null;
    const ctx = this.context();
    if (!ctx || !this.master || ctx.state !== 'running') return null;
    return { ctx, dest: this.master };
  }
}
export class AudioSystem {
  readonly bus = new AudioBus();
  readonly music: MusicPlayer;
  readonly sfx: Sfx;
  constructor() {
    this.music = new MusicPlayer(this.bus);
    this.sfx = new Sfx(this.bus);
    this.bus.installUnlockListeners();
  }
  loadMusic(segments: [number, number][], kinds: number[]): void {
    void this.music.load('/music/theme.mid', segments, kinds);
  }
}
